import { call, put } from 'redux-saga/effects';
import { getEventList } from '../../../services/api';

export function* fetchQuantidade() {
  try {
    const response = yield call(getEventList);
    const newFilter = {
      total: 0,
    };
    if (response && response.data) {
      response.data.filter.forEach(({ label, count }) => {
        newFilter[label] = count;
        newFilter.total += parseInt(count, 10);
      });
      yield put({
        type: 'EVENTOS/SET_EVENTOS',
        quantidade: newFilter,
        eventos: response.data.list,
      });
      yield put({
        type: 'EVENTOS/SET_ALARME',
        alarme: true,
      });
      // Marca o fetch como bem-sucedido para a UI poder limpar indicador
      // de "dados podem estar desatualizados".
      yield put({ type: 'EVENTOS/SET_FETCH_ERROR', error: null });
    }
  } catch (e) {
    // Em vez de silenciar, registra a falha em state + console.error.
    // Operador 24/7 precisa saber quando o sistema de eventos parou de
    // responder — o badge no menu pode estar mostrando count antigo.
    // eslint-disable-next-line no-console
    console.error('[eventos] fetchQuantidade falhou', e);
    yield put({
      type: 'EVENTOS/SET_FETCH_ERROR',
      error: e && e.message ? e.message : 'Falha ao buscar eventos',
    });
  }
}
